export default __webpack_public_path__ + "static/media/4-2.42a50634.webp";